import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import {
  Package,
  Truck,
  Eye,
  AlertTriangle,
  Upload,
  X,
  Calendar,
  MapPin,
  User,
  Phone,
  Mail,
  CheckCircle,
  Clock,
  Camera,
  FileImage,
  Plus,
  MessageSquare,
  Save
} from 'lucide-react';
import toast from 'react-hot-toast';
import { useAuth } from '../../contexts/AuthContext';
import { storeManagerService } from '../../services/storeManagerService';

const StoreManagerPortal = () => {
  const { user } = useAuth();
  const [shipments, setShipments] = useState([]);
  const [reminders, setReminders] = useState([]);
  const [isLoadingReminders, setIsLoadingReminders] = useState(false);
  const [showShipmentModal, setShowShipmentModal] = useState(false);
  const [viewingShipment, setViewingShipment] = useState(null);
  const [checkedItems, setCheckedItems] = useState({});
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportingShipment, setReportingShipment] = useState(null);
  const [parcelImages, setParcelImages] = useState([]);
  const [receivedImages, setReceivedImages] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('delivered');
  const [showReceivedModal, setShowReceivedModal] = useState(false);
  const [receivingShipment, setReceivingShipment] = useState(null);
  const [receivedItems, setReceivedItems] = useState({});
  const [remarks, setRemarks] = useState('');
  const presetRemarks = [
    'Package is in good shape',
    'Package is in bad shape',
    'Dress is damaged',
    'Dress has stains',
    'All items present',
    'Accessories missing',
    'Seals tampered',
    'Incorrect item received'
  ];
  const [selectedRemarkTags, setSelectedRemarkTags] = useState([]);

  const toggleRemarkTag = (tag) => {
    setSelectedRemarkTags((prev) => {
      const exists = prev.includes(tag);
      let next;
      if (exists) {
        next = prev.filter(t => t !== tag);
      } else {
        next = [...prev, tag];
      }
      const manualParts = (remarks || '')
        .split(/[;,]/)
        .map(s => s.trim().replace(/[.]+$/,''))
        .filter(s => s && !presetRemarks.includes(s));
      const combined = [...next, ...manualParts];
      let text = combined.join(', ');
      if (text && !/[.]$/.test(text)) {
        text = text + '.';
      }
      setRemarks(text);
      return next;
    });
  };
  const [showMissingItemsModal, setShowMissingItemsModal] = useState(false);
  const [missingItems, setMissingItems] = useState([]);
  const [missingItemsRemarks, setMissingItemsRemarks] = useState('');

  const {
    register: reportRegister,
    handleSubmit: handleReportSubmit,
    reset: resetReport,
    formState: { errors: reportErrors }
  } = useForm();

  // Mock shipments data
  useEffect(() => {
    // const mockShipments = [
    //   {
    //     id: 'SHP001',
    //     trackingNumber: 'TRK123456789',
    //     supplier: 'Fashion Hub Delhi',
    //     expectedDelivery: '2024-01-20',
    //     status: 'in_transit',
    //     totalItems: 15,
    //     totalValue: 45000,
    //     customerInfo: {
    //       name: 'Priya Sharma',
    //       phone: '+91 98765 43210',
    //       email: 'priya.sharma@email.com',
    //       address: '123 MG Road, Bangalore, Karnataka 560001'
    //     },
    //     items: [
    //       {
    //         id: 1,
    //         name: 'Designer Lehenga Set',
    //         type: 'lehenga',
    //         color: 'Royal Blue',
    //         size: 'M',
    //         quantity: 1,
    //         price: 15000,
    //         designer: 'Sabyasachi',
    //         sku: 'LEH001'
    //       },
    //       {
    //         id: 2,
    //         name: 'Silk Dupatta',
    //         type: 'dupatta',
    //         color: 'Golden',
    //         size: 'Free Size',
    //         quantity: 2,
    //         price: 3000,
    //         designer: 'Anita Dongre',
    //         sku: 'DUP001'
    //       },
    //       {
    //         id: 3,
    //         name: 'Embroidered Choli',
    //         type: 'choli',
    //         color: 'Pink',
    //         size: 'S',
    //         quantity: 1,
    //         price: 8000,
    //         designer: 'Manish Malhotra',
    //         sku: 'CHO001'
    //       }
    //     ],
    //     shippingDetails: {
    //       courierService: 'Blue Dart',
    //       weight: '2.5 kg',
    //       dimensions: '45x35x15 cm',
    //       shippedFrom: 'Mumbai Warehouse'
    //     }
    //   },
    //   {
    //     id: 'SHP002',
    //     trackingNumber: 'TRK987654321',
    //     supplier: 'Ethnic Wear Co.',
    //     expectedDelivery: '2024-01-22',
    //     status: 'delivered',
    //     totalItems: 8,
    //     totalValue: 28000,
    //     customerInfo: {
    //       name: 'Anjali Gupta',
    //       phone: '+91 87654 32109',
    //       email: 'anjali.gupta@email.com',
    //       address: '456 Park Street, Kolkata, West Bengal 700016'
    //     },
    //     items: [
    //       {
    //         id: 4,
    //         name: 'Banarasi Saree',
    //         type: 'saree',
    //         color: 'Maroon',
    //         size: 'Free Size',
    //         quantity: 1,
    //         price: 12000,
    //         designer: 'Traditional',
    //         sku: 'SAR001'
    //       },
    //       {
    //         id: 5,
    //         name: 'Designer Blouse',
    //         type: 'blouse',
    //         color: 'Gold',
    //         size: 'M',
    //         quantity: 1,
    //         price: 5000,
    //         designer: 'Ritu Kumar',
    //         sku: 'BLO001'
    //       }
    //     ],
    //     shippingDetails: {
    //       courierService: 'FedEx',
    //       weight: '1.8 kg',
    //       dimensions: '40x30x12 cm',
    //       shippedFrom: 'Delhi Warehouse'
    //     }
    //   },
    //   {
    //     id: 'SHP003',
    //     trackingNumber: 'TRK456789123',
    //     supplier: 'Bridal Collection',
    //     expectedDelivery: '2024-01-25',
    //     status: 'delivered',
    //     totalItems: 25,
    //     totalValue: 75000,
    //     customerInfo: {
    //       name: 'Meera Patel',
    //       phone: '+91 76543 21098',
    //       email: 'meera.patel@email.com',
    //       address: '789 Ring Road, Ahmedabad, Gujarat 380001'
    //     },
    //     items: [
    //       {
    //         id: 6,
    //         name: 'Heavy Bridal Lehenga',
    //         type: 'lehenga',
    //         color: 'Red',
    //         size: 'L',
    //         quantity: 1,
    //         price: 35000,
    //         designer: 'Tarun Tahiliani',
    //         sku: 'BRI001'
    //       },
    //       {
    //         id: 7,
    //         name: 'Matching Choli',
    //         type: 'choli',
    //         color: 'Red',
    //         size: 'L',
    //         quantity: 1,
    //         price: 15000,
    //         designer: 'Tarun Tahiliani',
    //         sku: 'BRI002'
    //       },
    //       {
    //         id: 8,
    //         name: 'Net Dupatta',
    //         type: 'dupatta',
    //         color: 'Red',
    //         size: 'Free Size',
    //         quantity: 1,
    //         price: 8000,
    //         designer: 'Tarun Tahiliani',
    //         sku: 'BRI003'
    //       }
    //     ],
    //     shippingDetails: {
    //       courierService: 'DHL',
    //       weight: '4.2 kg',
    //       dimensions: '60x45x20 cm',
    //       shippedFrom: 'Chennai Warehouse'
    //     }
    //   },
    //   {
    //     id: 'SHP004',
    //     trackingNumber: 'TRK111222333',
    //     supplier: 'Designer Boutique',
    //     expectedDelivery: '2024-01-18',
    //     status: 'delivered',
    //     totalItems: 12,
    //     totalValue: 35000,
    //     customerInfo: {
    //       name: 'Ritu Singh',
    //       phone: '+91 65432 10987',
    //       email: 'ritu.singh@email.com',
    //       address: '321 MG Road, Pune, Maharashtra 411001'
    //     },
    //     items: [
    //       {
    //         id: 9,
    //         name: 'Party Wear Lehenga',
    //         type: 'lehenga',
    //         color: 'Black',
    //         size: 'L',
    //         quantity: 1,
    //         price: 18000,
    //         designer: 'Rohit Bal',
    //         sku: 'LEH002'
    //       },
    //       {
    //         id: 10,
    //         name: 'Net Dupatta',
    //         type: 'dupatta',
    //         color: 'Silver',
    //         size: 'Free Size',
    //         quantity: 1,
    //         price: 4000,
    //         designer: 'Rohit Bal',
    //         sku: 'DUP002'
    //       },
    //       {
    //         id: 11,
    //         name: 'Crop Top Choli',
    //         type: 'choli',
    //         color: 'Black',
    //         size: 'L',
    //         quantity: 1,
    //         price: 8000,
    //         designer: 'Rohit Bal',
    //         sku: 'CHO002'
    //       }
    //     ],
    //     shippingDetails: {
    //       courierService: 'India Post',
    //       weight: '1.5 kg',
    //       dimensions: '35x25x10 cm',
    //       shippedFrom: 'Pune Warehouse'
    //     }
    //   }
    // ];
    // setShipments(mockShipments);
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case 'pending': return '#f59e0b';
      case 'in_transit': return '#3b82f6';
      case 'delivered': return '#10b981';
      case 'delayed': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'pending': return Clock;
      case 'in_transit': return Truck;
      case 'delivered': return CheckCircle;
      case 'delayed': return AlertTriangle;
      default: return Package;
    }
  };

  const openShipmentModal = (shipment) => {
    // initialize checked state for each item as false
    const initialChecked = (shipment.items || []).reduce((acc, item) => {
      acc[item.id] = false;
      return acc;
    }, {});
    setCheckedItems(initialChecked);
    setViewingShipment(shipment);
    setShowShipmentModal(true);
  };

  const closeShipmentModal = () => {
    setShowShipmentModal(false);
    setViewingShipment(null);
    setCheckedItems({});
  };

  const openReportModal = (shipment) => {
    setReportingShipment(shipment);
    setShowReportModal(true);
    setParcelImages([]);
    setReceivedImages([]);
  };

  const closeReportModal = () => {
    setShowReportModal(false);
    setReportingShipment(null);
    setParcelImages([]);
    setReceivedImages([]);
    resetReport();
  };

  const openMissingItemsModal = (shipment) => {
    setReportingShipment(shipment);
    setMissingItems([]);
    setMissingItemsRemarks('');
    setShowMissingItemsModal(true);
  };

  const closeMissingItemsModal = () => {
    setShowMissingItemsModal(false);
    setReportingShipment(null);
    setMissingItems([]);
    setMissingItemsRemarks('');
  };

  const handleMissingItemsSubmit = async () => {
    if (missingItems.length === 0) {
      toast.error('Please select at least one missing item');
      return;
    }

    if (!missingItemsRemarks.trim()) {
      toast.error('Please add remarks about the missing items');
      return;
    }

    try {
      const missingItemsData = {
        shipmentId: reportingShipment.id,
        missingItems: missingItems,
        remarks: missingItemsRemarks,
        reportedAt: new Date().toISOString()
      };

      // Call API to report missing items
      await storeManagerService.reportMissingItems(reportingShipment.id, missingItemsData);
      
      toast.success('Missing items reported successfully');
      closeMissingItemsModal();
      
      // Update shipment status
      setShipments(prev => prev.map(shipment => 
        shipment.id === reportingShipment.id 
          ? { ...shipment, status: 'missing_items_reported' }
          : shipment
      ));
    } catch (error) {
      console.error('Error reporting missing items:', error);
      toast.error('Failed to report missing items');
    }
  };

  const openReceivedModal = (shipment) => {
    // Initialize received state for each item as false
    const initialReceived = (shipment.items || []).reduce((acc, item) => {
      acc[item.id] = false;
      return acc;
    }, {});
    setReceivedItems(initialReceived);
    setRemarks('');
    setReceivingShipment(shipment);
    setShowReceivedModal(true);
  };

  const closeReceivedModal = () => {
    setShowReceivedModal(false);
    setReceivingShipment(null);
    setReceivedItems({});
    setRemarks('');
  };

  const handleReceivedSubmit = () => {
    const receivedCount = Object.values(receivedItems).filter(Boolean).length;
    const totalItems = receivingShipment?.items?.length || 0;
    
    if (receivedCount === 0) {
      toast.error('Please check at least one item as received');
      return;
    }

    const receivedData = {
      shipmentId: receivingShipment.id,
      receivedItems: receivedItems,
      remarks: remarks,
      receivedCount: receivedCount,
      totalItems: totalItems,
      receivedAt: new Date().toISOString()
    };

    console.log('Received items submitted:', receivedData);
    toast.success(`Successfully confirmed ${receivedCount}/${totalItems} items received!`);
    
    // Update shipment status to received
    setShipments(prev => prev.map(shipment => 
      shipment.id === receivingShipment.id 
        ? { ...shipment, status: 'received' }
        : shipment
    ));
    
    closeReceivedModal();
  };

  const handleParcelImageUpload = (e) => {
    const files = Array.from(e.target.files);
    files.forEach(file => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setParcelImages(prev => [...prev, { file, preview: reader.result }]);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleReceivedImageUpload = (e) => {
    const files = Array.from(e.target.files);
    files.forEach(file => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setReceivedImages(prev => [...prev, { file, preview: reader.result }]);
      };
      reader.readAsDataURL(file);
    });
  };

  const removeParcelImage = (index) => {
    setParcelImages(prev => prev.filter((_, i) => i !== index));
  };

  const removeReceivedImage = (index) => {
    setReceivedImages(prev => prev.filter((_, i) => i !== index));
  };

  const onReportSubmit = (data) => {
    const reportData = {
      ...data,
      shipmentId: reportingShipment.id,
      parcelImages: parcelImages,
      receivedImages: receivedImages,
      reportedAt: new Date().toISOString()
    };
    
    console.log('Report submitted:', reportData);
    toast.success('Report submitted successfully!');
    closeReportModal();
  };

  const filteredShipments = shipments.filter(shipment => {
    const matchesSearch = shipment.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         shipment.supplier.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         shipment.customerInfo.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'all' || shipment.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  // Debug logging
  console.log('Status filter:', statusFilter);
  console.log('Filtered shipments:', filteredShipments);
  console.log('Delivered shipments:', shipments.filter(s => s.status === 'delivered'));

  // Load payment reminders (admin-visible)
  const loadReminders = async () => {
    try {
      setIsLoadingReminders(true);
      const res = await storeManagerService.getReminders({ status: 'pending' });
      const items = res?.data?.data?.data || []; // supports pagination shape
      setReminders(items);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoadingReminders(false);
    }
  };

  useEffect(() => {
    loadReminders();
  }, []);

  const handleSendReminder = async (reminderId) => {
    try {
      await storeManagerService.sendReminder(reminderId);
      toast.success('Reminder sent');
      loadReminders();
    } catch (e) {
      toast.error(e?.response?.data?.message || 'Failed to send reminder');
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-title">Reminders</h1>
          <p className="page-subtitle">View pending reminders and send payment emails to buyers</p>
        </div>
      </div>

      {/* Payment Reminders Panel */}
      <div style={{ marginBottom: '24px', padding: '16px', border: '1px solid #e5e7eb', borderRadius: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Clock size={18} />
            <h3 style={{ margin: 0 }}>Payment Reminders (pending)</h3>
          </div>
          <button
            className="btn btn-secondary"
            onClick={loadReminders}
            disabled={isLoadingReminders}
          >
            Refresh
          </button>
        </div>
        <div style={{ marginTop: 12 }}>
          {isLoadingReminders ? (
            <p>Loading...</p>
          ) : reminders.length === 0 ? (
            <p>No pending reminders.</p>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table className="table" style={{ width: '100%', minWidth: 800 }}>
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Listing</th>
                    <th>Buyer</th>
                    <th>Attempt</th>
                    <th>Scheduled At</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {reminders.map((r) => (
                    <tr key={r.id}>
                      <td>{r.order_id}</td>
                      <td>{r.listing_id}</td>
                      <td>{r.buyer?.name || r.buyer_id}</td>
                      <td>{r.attempt}/3</td>
                      <td>{new Date(r.scheduled_at).toLocaleString()}</td>
                      <td><span className="badge">{r.status}</span></td>
                      <td style={{ textAlign: 'right' }}>
                        <button className="btn btn-primary" onClick={() => handleSendReminder(r.id)}>
                          Send Now
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Filters */}
      {/* <div style={{
        display: 'flex',
        gap: '16px',
        marginBottom: '24px',
        flexWrap: 'wrap'
      }}>

        <div style={{ position: 'relative', width: '300px' }}>
          <Package
            size={18}
            style={{
              position: 'absolute',
              left: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#6b7280'
            }}
          />
          <input
            type="text"
            placeholder="Search shipments..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-box"
            style={{ paddingLeft: '40px', width: '100%', height: '44px' }}
          />
        </div>


        <div style={{ position: 'relative', width: '200px' }}>
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="form-select"
            style={{ width: '100%', height: '44px' }}
          >
            <option value="all">All Status</option>
            <option value="pending">Pending</option>
            <option value="in_transit">In Transit</option>
            <option value="delivered">Delivered</option>
            <option value="delayed">Delayed</option>
          </select>
        </div>
      </div> */}

      {/* Shipments Table */}
      {/* <div style={{ overflowX: 'auto' }}>
        <table className="table">
          <thead>
            <tr>
              <th>Shipment ID</th>
              <th>Supplier</th>
              <th>Customer</th>
              <th>Items</th>
              <th>Value</th>
              <th>Expected Delivery</th>
              <th>Status</th>
              <th style={{ width: '120px' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredShipments.map((shipment) => {
              const StatusIcon = getStatusIcon(shipment.status);
              return (
                <tr key={shipment.id}>
                  <td>
                    <div style={{ fontWeight: '600', color: '#111827' }}>
                      {shipment.id}
                    </div>
                    <div style={{ fontSize: '12px', color: '#6b7280' }}>
                      {shipment.trackingNumber}
                    </div>
                  </td>
                  <td>{shipment.supplier}</td>
                  <td>
                    <div>{shipment.customerInfo.name}</div>
                    <div style={{ fontSize: '12px', color: '#6b7280' }}>
                      {shipment.customerInfo.phone}
                    </div>
                  </td>
                  <td>
                    <span style={{
                      backgroundColor: '#f3f4f6',
                      color: '#374151',
                      padding: '4px 8px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      fontWeight: '500'
                    }}>
                      {shipment.totalItems} items
                    </span>
                  </td>
                  <td>
                    <span style={{ fontWeight: '600', color: '#059669' }}>
                      ₹{shipment.totalValue.toLocaleString()}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <Calendar size={12} color="#6b7280" />
                      <span style={{ fontSize: '12px' }}>
                        {new Date(shipment.expectedDelivery).toLocaleDateString()}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                      backgroundColor: getStatusColor(shipment.status),
                      color: 'white',
                      padding: '4px 8px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      fontWeight: '500',
                      width: 'fit-content'
                    }}>
                      <StatusIcon size={12} />
                      {shipment.status.replace('_', ' ').charAt(0).toUpperCase() + shipment.status.replace('_', ' ').slice(1)}
                    </div>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <button
                        onClick={() => openShipmentModal(shipment)}
                        className="btn btn-secondary"
                        style={{
                          fontSize: '11px',
                          padding: '8px',
                          minWidth: 'auto'
                        }}
                        title="View Details"
                      >
                        <Eye size={14} />
                      </button>
                      {shipment.status === 'delivered' ? (
                        <>
                          <button
                            onClick={() => openReceivedModal(shipment)}
                            className="btn"
                            style={{
                              fontSize: '11px',
                              padding: '8px',
                              minWidth: 'auto',
                              backgroundColor: '#10b981',
                              color: 'white',
                              border: '1px solid #10b981'
                            }}
                            title="Mark as Received"
                          >
                            <CheckCircle size={14} />
                          </button>
                          <button
                            onClick={() => openMissingItemsModal(shipment)}
                            className="btn"
                            style={{
                              fontSize: '11px',
                              padding: '8px',
                              minWidth: 'auto',
                              backgroundColor: '#ef4444',
                              color: 'white',
                              border: '1px solid #ef4444'
                            }}
                            title="Report Missing Items"
                          >
                            <AlertTriangle size={14} />
                          </button>
                          <button
                            onClick={() => openReportModal(shipment)}
                            className="btn"
                            style={{
                              fontSize: '11px',
                              padding: '8px',
                              minWidth: 'auto',
                              backgroundColor: '#f59e0b',
                              color: 'white',
                              border: '1px solid #f59e0b'
                            }}
                            title="Report Issues"
                          >
                            <MessageSquare size={14} />
                          </button>
                        </>
                      ) : (
                        <span style={{ fontSize: '12px', color: '#6b7280' }}>
                          Status: {shipment.status}
                        </span>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div> */}
{/* 
      {filteredShipments.length === 0 && (
        <div style={{
          textAlign: 'center',
          padding: '48px 24px',
          color: '#6b7280'
        }}>
          <Package size={48} style={{ margin: '0 auto 16px', opacity: 0.5 }} />
          <p>No shipments found matching your criteria</p>
        </div>
      )} */}

      {/* Shipment Details Modal */}
      {showShipmentModal && viewingShipment && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: '800px', width: '95%' }}>
            <div className="modal-header">
              <h2>Shipment Details - {viewingShipment.id}</h2>
              <button onClick={closeShipmentModal} className="modal-close">
                <X size={20} />
              </button>
            </div>
            
            <div className="modal-body" style={{ padding: '24px' }}>
              {/* Shipment Info */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '24px',
                marginBottom: '32px'
              }}>
                <div>
                  <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px', color: '#111827' }}>
                    Shipment Information
                  </h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ color: '#6b7280' }}>Tracking Number:</span>
                      <span style={{ fontWeight: '500' }}>{viewingShipment.trackingNumber}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ color: '#6b7280' }}>Supplier:</span>
                      <span style={{ fontWeight: '500' }}>{viewingShipment.supplier}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ color: '#6b7280' }}>Expected Delivery:</span>
                      <span style={{ fontWeight: '500' }}>{new Date(viewingShipment.expectedDelivery).toLocaleDateString()}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ color: '#6b7280' }}>Total Value:</span>
                      <span style={{ fontWeight: '600', color: '#059669' }}>₹{viewingShipment.totalValue.toLocaleString()}</span>
                    </div>
                  </div>
                </div>

                <div>
                  <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px', color: '#111827' }}>
                    Customer Information
                  </h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <User size={14} color="#6b7280" />
                      <span>{viewingShipment.customerInfo.name}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Phone size={14} color="#6b7280" />
                      <span>{viewingShipment.customerInfo.phone}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Mail size={14} color="#6b7280" />
                      <span>{viewingShipment.customerInfo.email}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                      <MapPin size={14} color="#6b7280" style={{ marginTop: '2px' }} />
                      <span style={{ fontSize: '14px' }}>{viewingShipment.customerInfo.address}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Items List */}
              <div style={{ marginBottom: '24px' }}>
                <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px', color: '#111827' }}>
                  Order Items ({viewingShipment.totalItems} items)
                </h3>
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#f9fafb' }}>
                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Item</th>
                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Type</th>
                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Color</th>
                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Size</th>
                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Qty</th>
                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Price</th>
                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Designer</th>
                      </tr>
                    </thead>
                    <tbody>
                      {viewingShipment.items.map((item, index) => (
                        <tr key={item.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                          <td style={{ padding: '12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <input
                                type="checkbox"
                                checked={!!checkedItems[item.id]}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  setCheckedItems(prev => ({ ...prev, [item.id]: isChecked }));
                                }}
                                aria-label={`Select ${item.name}`}
                                style={{ width: '16px', height: '16px' }}
                              />
                              <span style={{ fontWeight: '500' }}>{item.name}</span>
                            </div>
                            <div style={{ fontSize: '12px', color: '#6b7280' }}>SKU: {item.sku}</div>
                          </td>
                          <td style={{ padding: '12px' }}>
                            <span style={{
                              backgroundColor: '#dbeafe',
                              color: '#1e40af',
                              padding: '2px 8px',
                              borderRadius: '12px',
                              fontSize: '12px',
                              fontWeight: '500'
                            }}>
                              {item.type}
                            </span>
                          </td>
                          <td style={{ padding: '12px' }}>{item.color}</td>
                          <td style={{ padding: '12px' }}>{item.size}</td>
                          <td style={{ padding: '12px' }}>{item.quantity}</td>
                          <td style={{ padding: '12px', fontWeight: '600', color: '#059669' }}>
                            ₹{item.price.toLocaleString()}
                          </td>
                          <td style={{ padding: '12px' }}>{item.designer}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Shipping Details */}
              <div>
                <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px', color: '#111827' }}>
                  Shipping Details
                </h3>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '16px',
                  padding: '16px',
                  backgroundColor: '#f9fafb',
                  borderRadius: '8px'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ color: '#6b7280' }}>Courier Service:</span>
                    <span style={{ fontWeight: '500' }}>{viewingShipment.shippingDetails.courierService}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ color: '#6b7280' }}>Weight:</span>
                    <span style={{ fontWeight: '500' }}>{viewingShipment.shippingDetails.weight}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ color: '#6b7280' }}>Dimensions:</span>
                    <span style={{ fontWeight: '500' }}>{viewingShipment.shippingDetails.dimensions}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ color: '#6b7280' }}>Shipped From:</span>
                    <span style={{ fontWeight: '500' }}>{viewingShipment.shippingDetails.shippedFrom}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Report Issues Modal */}
      {showReportModal && reportingShipment && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: '900px', width: '95%' }}>
            <div className="modal-header">
              <h2>Report Issues - {reportingShipment.id}</h2>
              <button onClick={closeReportModal} className="modal-close">
                <X size={20} />
              </button>
            </div>
            
            <form onSubmit={handleReportSubmit(onReportSubmit)} className="modal-body" style={{ padding: '24px' }}>
              {/* Issue Type */}
              <div className="form-group">
                <label className="form-label">Issue Type</label>
                <select
                  {...reportRegister('issueType', { required: 'Please select an issue type' })}
                  className="form-select"
                >
                  <option value="">Select issue type</option>
                  <option value="missing_items">Missing Items</option>
                  <option value="damaged_box">Damaged Box/Packaging</option>
                  <option value="damaged_items">Damaged Items</option>
                  <option value="wrong_items">Wrong Items Received</option>
                  <option value="other">Other</option>
                </select>
                {reportErrors.issueType && <span className="error-message">{reportErrors.issueType.message}</span>}
              </div>

              {/* Description */}
              <div className="form-group">
                <label className="form-label">Description</label>
                <textarea
                  {...reportRegister('description', { required: 'Please provide a description' })}
                  className="form-textarea"
                  rows={4}
                  placeholder="Describe the issue in detail..."
                />
                {reportErrors.description && <span className="error-message">{reportErrors.description.message}</span>}
              </div>

              {/* Images Upload Section */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '24px',
                marginBottom: '24px'
              }}>
                {/* Parcel Images */}
                <div>
                  <label className="form-label">Parcel/Box Images</label>
                  <div style={{
                    border: '2px dashed #d1d5db',
                    borderRadius: '8px',
                    padding: '16px',
                    textAlign: 'center',
                    marginBottom: '16px'
                  }}>
                    <input
                      type="file"
                      multiple
                      accept="image/*"
                      onChange={handleParcelImageUpload}
                      style={{ display: 'none' }}
                      id="parcel-image-upload"
                    />
                    <label htmlFor="parcel-image-upload" style={{ cursor: 'pointer' }}>
                      <Camera size={24} color="#6b7280" style={{ marginBottom: '8px' }} />
                      <p style={{ color: '#6b7280', margin: 0, fontSize: '14px' }}>
                        Upload parcel images
                      </p>
                      <p style={{ color: '#9ca3af', fontSize: '12px', margin: '4px 0 0' }}>
                        JPG, PNG images of the parcel/box condition
                      </p>
                    </label>
                  </div>

                  {/* Parcel Images Preview */}
                  {parcelImages.length > 0 && (
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))',
                      gap: '8px'
                    }}>
                      {parcelImages.map((image, index) => (
                        <div key={index} style={{ position: 'relative' }}>
                          <img
                            src={image.preview}
                            alt={`Parcel ${index + 1}`}
                            style={{
                              width: '100%',
                              height: '80px',
                              objectFit: 'cover',
                              borderRadius: '4px',
                              border: '1px solid #e5e7eb'
                            }}
                          />
                          <button
                            type="button"
                            onClick={() => removeParcelImage(index)}
                            style={{
                              position: 'absolute',
                              top: '4px',
                              right: '4px',
                              background: 'rgba(239, 68, 68, 0.9)',
                              color: 'white',
                              border: 'none',
                              borderRadius: '50%',
                              width: '20px',
                              height: '20px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer'
                            }}
                            title="Remove image"
                          >
                            <X size={12} />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Received Items Images */}
                <div>
                  <label className="form-label">Received Items Images</label>
                  <div style={{
                    border: '2px dashed #d1d5db',
                    borderRadius: '8px',
                    padding: '16px',
                    textAlign: 'center',
                    marginBottom: '16px'
                  }}>
                    <input
                      type="file"
                      multiple
                      accept="image/*"
                      onChange={handleReceivedImageUpload}
                      style={{ display: 'none' }}
                      id="received-image-upload"
                    />
                    <label htmlFor="received-image-upload" style={{ cursor: 'pointer' }}>
                      <FileImage size={24} color="#6b7280" style={{ marginBottom: '8px' }} />
                      <p style={{ color: '#6b7280', margin: 0, fontSize: '14px' }}>
                        Upload item images
                      </p>
                      <p style={{ color: '#9ca3af', fontSize: '12px', margin: '4px 0 0' }}>
                        Images of dupatta, choli, lehenga, etc.
                      </p>
                    </label>
                  </div>

                  {/* Received Images Preview */}
                  {receivedImages.length > 0 && (
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))',
                      gap: '8px'
                    }}>
                      {receivedImages.map((image, index) => (
                        <div key={index} style={{ position: 'relative' }}>
                          <img
                            src={image.preview}
                            alt={`Received ${index + 1}`}
                            style={{
                              width: '100%',
                              height: '80px',
                              objectFit: 'cover',
                              borderRadius: '4px',
                              border: '1px solid #e5e7eb'
                            }}
                          />
                          <button
                            type="button"
                            onClick={() => removeReceivedImage(index)}
                            style={{
                              position: 'absolute',
                              top: '4px',
                              right: '4px',
                              background: 'rgba(239, 68, 68, 0.9)',
                              color: 'white',
                              border: 'none',
                              borderRadius: '50%',
                              width: '20px',
                              height: '20px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer'
                            }}
                            title="Remove image"
                          >
                            <X size={12} />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Action Buttons */}
              <div style={{
                display: 'flex',
                gap: '12px',
                justifyContent: 'flex-end'
              }}>
                <button type="button" onClick={closeReportModal} className="btn btn-secondary">
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Submit Report
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Received Items Modal */}
      {showReceivedModal && receivingShipment && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: '700px', width: '95%' }}>
            <div className="modal-header">
              <h2>Confirm Received Items - {receivingShipment.id}</h2>
              <button onClick={closeReceivedModal} className="modal-close">
                <X size={20} />
              </button>
            </div>
            
            <div className="modal-body" style={{ padding: '24px' }}>
              {/* Shipment Info */}
              <div style={{
                backgroundColor: '#f9fafb',
                padding: '16px',
                borderRadius: '8px',
                marginBottom: '24px'
              }}>
                <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', color: '#111827' }}>
                  Shipment Details
                </h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', fontSize: '14px' }}>
                  <div>
                    <span style={{ color: '#6b7280' }}>Tracking Number:</span>
                    <span style={{ fontWeight: '500', marginLeft: '8px' }}>{receivingShipment.trackingNumber}</span>
                  </div>
                  <div>
                    <span style={{ color: '#6b7280' }}>Supplier:</span>
                    <span style={{ fontWeight: '500', marginLeft: '8px' }}>{receivingShipment.supplier}</span>
                  </div>
                  <div>
                    <span style={{ color: '#6b7280' }}>Total Items:</span>
                    <span style={{ fontWeight: '500', marginLeft: '8px' }}>{receivingShipment.totalItems}</span>
                  </div>
                  <div>
                    <span style={{ color: '#6b7280' }}>Expected Delivery:</span>
                    <span style={{ fontWeight: '500', marginLeft: '8px' }}>{new Date(receivingShipment.expectedDelivery).toLocaleDateString()}</span>
                  </div>
                </div>
              </div>

              {/* Items Checklist */}
              <div style={{ marginBottom: '24px' }}>
                <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px', color: '#111827' }}>
                  Items Received Checklist
                </h3>
                <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#f9fafb' }}>
                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#374151', width: '40px' }}>✓</th>
                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Item</th>
                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Type</th>
                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Color</th>
                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Size</th>
                        <th style={{ padding: '12px', textAlign: 'center', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Qty</th>
                        <th style={{ padding: '12px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#374151' }}>Designer</th>
                      </tr>
                    </thead>
                    <tbody>
                      {receivingShipment.items.map((item, index) => (
                        <tr key={item.id} style={{ borderTop: '1px solid #e5e7eb' }}>
                          <td style={{ padding: '12px', textAlign: 'center' }}>
                            <input
                              type="checkbox"
                              checked={!!receivedItems[item.id]}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setReceivedItems(prev => ({ ...prev, [item.id]: isChecked }));
                              }}
                              aria-label={`Mark ${item.name} as received`}
                              style={{ width: '16px', height: '16px' }}
                            />
                          </td>
                          <td style={{ padding: '12px' }}>
                            <div style={{ fontWeight: '500' }}>{item.name}</div>
                            <div style={{ fontSize: '12px', color: '#6b7280' }}>SKU: {item.sku}</div>
                          </td>
                          <td style={{ padding: '12px' }}>
                            <span style={{
                              backgroundColor: '#dbeafe',
                              color: '#1e40af',
                              padding: '2px 8px',
                              borderRadius: '12px',
                              fontSize: '12px',
                              fontWeight: '500'
                            }}>
                              {item.type}
                            </span>
                          </td>
                          <td style={{ padding: '12px' }}>{item.color}</td>
                          <td style={{ padding: '12px' }}>{item.size}</td>
                          <td style={{ padding: '12px', textAlign: 'center' }}>{item.quantity}</td>
                          <td style={{ padding: '12px' }}>{item.designer}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Remarks Section */}
              <div style={{ marginBottom: '24px' }}>
                <label className="form-label" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                  <MessageSquare size={16} color="#6b7280" />
                  Remarks (Optional)
                </label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '8px' }}>
                  {presetRemarks.map((tag) => {
                    const active = selectedRemarkTags.includes(tag);
                    return (
                      <button
                        key={tag}
                        type="button"
                        onClick={() => toggleRemarkTag(tag)}
                        style={{
                          padding: '6px 10px',
                          borderRadius: '16px',
                          border: active ? '1px solid #2563eb' : '1px solid #d1d5db',
                          backgroundColor: active ? '#2563eb10' : 'white',
                          color: '#111827',
                          fontSize: '12px',
                          cursor: 'pointer'
                        }}
                      >
                        {tag}
                      </button>
                    );
                  })}
                </div>
                <textarea
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder="Add any notes about the received items, condition, or discrepancies..."
                  className="form-textarea"
                  rows={3}
                  style={{ width: '100%' }}
                />
              </div>

              {/* Summary */}
              <div style={{
                backgroundColor: '#f0f9ff',
                border: '1px solid #bae6fd',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '24px'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontWeight: '500', color: '#0369a1' }}>
                    Items Checked: {Object.values(receivedItems).filter(Boolean).length} / {receivingShipment.totalItems}
                  </span>
                  <span style={{ fontSize: '14px', color: '#6b7280' }}>
                    {Object.values(receivedItems).filter(Boolean).length === receivingShipment.totalItems 
                      ? 'All items received ✓' 
                      : 'Some items missing'}
                  </span>
                </div>
              </div>

              {/* Action Buttons */}
              <div style={{
                display: 'flex',
                gap: '12px',
                justifyContent: 'flex-end'
              }}>
                <button type="button" onClick={closeReceivedModal} className="btn btn-secondary">
                  Cancel
                </button>
                <button 
                  type="button" 
                  onClick={handleReceivedSubmit}
                  className="btn btn-primary"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <Save size={16} />
                  Confirm Received Items
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Missing Items Modal */}
      {showMissingItemsModal && reportingShipment && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: '600px', width: '95%' }}>
            <div className="modal-header">
              <h2>Report Missing Items - {reportingShipment.id}</h2>
              <button onClick={closeMissingItemsModal} className="modal-close">
                <X size={20} />
              </button>
            </div>
            
            <div className="modal-body" style={{ padding: '24px' }}>
              {/* Missing Items Selection */}
              <div style={{ marginBottom: '24px' }}>
                <label className="form-label" style={{ display: 'block', marginBottom: '12px', fontWeight: '500' }}>
                  Select Missing Items
                </label>
                <div style={{ 
                  border: '1px solid #e5e7eb', 
                  borderRadius: '8px', 
                  maxHeight: '300px', 
                  overflowY: 'auto' 
                }}>
                  {reportingShipment.items?.map((item, index) => (
                    <label key={index} style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      padding: '12px 16px',
                      borderBottom: index < reportingShipment.items.length - 1 ? '1px solid #e5e7eb' : 'none',
                      cursor: 'pointer',
                      transition: 'background-color 0.2s'
                    }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                      <input
                        type="checkbox"
                        checked={missingItems.includes(item.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setMissingItems([...missingItems, item.id]);
                          } else {
                            setMissingItems(missingItems.filter(id => id !== item.id));
                          }
                        }}
                        style={{ marginRight: '12px', width: '18px', height: '18px', cursor: 'pointer' }}
                      />
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: '500', marginBottom: '4px' }}>{item.name}</div>
                        <div style={{ fontSize: '12px', color: '#6b7280' }}>
                          SKU: {item.sku} | {item.type} | {item.color} | {item.size}
                        </div>
                      </div>
                    </label>
                  ))}
                </div>
              </div>

              {/* Remarks */}
              <div style={{ marginBottom: '24px' }}>
                <label className="form-label" style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                  Remarks *
                </label>
                <textarea
                  value={missingItemsRemarks}
                  onChange={(e) => setMissingItemsRemarks(e.target.value)}
                  rows={4}
                  style={{ 
                    width: '100%', 
                    padding: '12px', 
                    border: '1px solid #d1d5db', 
                    borderRadius: '6px',
                    fontSize: '14px',
                    resize: 'vertical'
                  }}
                  placeholder="Please provide details about the missing items..."
                />
              </div>

              {/* Action Buttons */}
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                <button 
                  onClick={closeMissingItemsModal} 
                  className="btn btn-secondary"
                  style={{
                    padding: '10px 20px',
                    borderRadius: '6px',
                    border: '1px solid #d1d5db',
                    backgroundColor: 'white',
                    color: '#374151',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleMissingItemsSubmit}
                  className="btn btn-primary"
                  style={{
                    padding: '10px 20px',
                    borderRadius: '6px',
                    border: '1px solid #ef4444',
                    backgroundColor: '#ef4444',
                    color: 'white',
                    cursor: 'pointer'
                  }}
                  disabled={missingItems.length === 0 || !missingItemsRemarks.trim()}
                >
                  Report Missing Items
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StoreManagerPortal;
